import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import '../css/paste.css';
import {addBoardFunction} from './BoardFunction';



export default class cancelBadge extends Component{
  
  constructor(){
    super();

    this.state={
      isit_cancel_aru:false,
      cancel_array:[],
      show_data:false
    }
  }

  
  componentDidMount () {
    let res = addBoardFunction.getCancelData(this.props.tonya_name_f, this.props.data.auth_obj);
    if(res.length>0){
      this.setState({isit_cancel_aru:true});
      this.setState({cancel_array:res});
    }
  }
  
  
    
  render(){
    var clickButton = async (e) => {
			console.dir(e.target);
      this.setState({show_data:true});
    }

    var closeShow = async (e) => {
      this.setState({show_data:false});
    }

    var clickButton2 = async (e) => {
			console.dir(e.target);
      let res = addBoardFunction.changeFinishData(e.target.dataset.cmId, this.props.data.auth_obj);
      
    }

    return (


        
      <div className="cancel-badge">
        {this.state.show_data ? 
          <>
            <div className="cancel-badge-table position-relative">
              <table>
                <tr>
                  <td>管理番号</td>
                  <td>ステータス</td>
                  <td>CMフェーズ</td>
                  <td>JAN</td>
                  <td>発注No.</td>
                  <td>受注数</td>
                  <td>管理的に完了にする？</td>
                </tr>
                {this.state.cancel_array.map((row, index)=>{
                  return(
                    <tr>
                      <td>{row.cm_order_no}</td>
                      <td>{row.hattyuu_status_now}</td>
                      <td>{row.cm_phase}</td>
                      <td>{row.JAN}</td>
                      <td>{row.hattyuu_no}</td>
                      <td>{row.amount}</td>
                      <td>
                      <Button variant="secondary" data-cm-id={row.cm_order_no} size="sm" onClick={event=>clickButton2(event)}>
                        する
				              </Button>
                      </td>
                    </tr>
                  
                  )
                })}
              </table>

                <span variant="secondary" size="sm" onClick={event=>closeShow (event)} className="cancel-close-button">
                  <i className="bi bi-x-circle"></i>
				        </span>
           
            </div>
          </> 
        : 
          <>
            {this.state.cancel_array.length>0 ? 
              <>
                <span data-db-name={this.props.tonya_name_f} size="sm" onClick={event=>clickButton(event)} className="click-pointer-elem">キ</span>
              </> 
            : <></>}
          </>
        }
      </div>
    );
  }
}
  
  

	//{...this.props}